<template>
    <ChangeModal help="HelpAboutMe">
        <span slot="title">About Me</span>
    </ChangeModal>
</template>

<script>
export default {
    label: 'About Me',
};
</script>
